module.exports = __webpack_public_path__ + "static/media/step2-img1.0db9f8b7.png";